import { render, staticRenderFns } from "./2_007_cf_dcz.vue?vue&type=template&id=072ba2ca"
import script from "./2_007_cf_dcz.vue?vue&type=script&lang=js"
export * from "./2_007_cf_dcz.vue?vue&type=script&lang=js"
import style0 from "./2_007_cf_dcz.vue?vue&type=style&index=0&id=072ba2ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports